import { Building2 } from "lucide-react";
import { accountShareTry, allocationsOf, tryValue } from "../lib/format";
import { fmtDisplay } from "../lib/currency";

const UNASSIGNED = "Atanmamış";

export default function AccountSummary({ transactions, collections, accounts, rate = 0, currency = "TRY", rates = {}, activeAccount, onSelect }) {
  const f = value => fmtDisplay(value, currency, rates);
  const keys = [...accounts];
  const hasUnassigned = transactions.some(x => x.kind === "income" && !x.account) || collections.some(c => !allocationsOf(c).length);
  if (hasUnassigned) keys.push(UNASSIGNED);

  const rows = keys.map(name => {
    const match = value => name === UNASSIGNED ? !value : value === name;
    const income = transactions.filter(x => x.kind === "income" && match(x.account)).reduce((s, x) => s + tryValue(x, rate), 0);
    const gross = transactions.filter(x => x.kind === "income" && match(x.account)).reduce((s, x) => s + tryValue({ ...x, amount: x.gross_revenue ?? x.amount }, rate), 0);
    const collected = name === UNASSIGNED
      ? collections.filter(c => !allocationsOf(c).length).reduce((s, c) => s + tryValue(c, rate), 0)
      : collections.reduce((s, c) => s + accountShareTry(c, name, rate), 0);
    return { name, income, gross, collected, outstanding: income - collected };
  }).filter(r => r.income || r.collected);

  const total = rows.reduce((a, r) => ({
    income: a.income + r.income, gross: a.gross + r.gross, collected: a.collected + r.collected, outstanding: a.outstanding + r.outstanding,
  }), { income: 0, gross: 0, collected: 0, outstanding: 0 });

  return (
    <section className="panel account-summary" data-testid="account-summary">
      <div className="panel-head">
        <div>
          <p className="eyebrow">HESAP BAZINDA</p>
          <h3>Gelir ve tahsilat dağılımı</h3>
        </div>
        <Building2 size={18}/>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Hesap</th><th className="right">Ciro</th><th className="right">Gelir (komisyon)</th>
              <th className="right">Tahsil edilen</th><th className="right">Kalan alacak</th><th className="right">Tahsil oranı</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.name} className={activeAccount === r.name ? "row-active" : ""} data-testid={`account-summary-row-${r.name}`}
                onClick={() => onSelect?.(activeAccount === r.name ? "" : r.name)} style={{ cursor: "pointer" }}>
                <td><b>{r.name}</b></td>
                <td className="right">{f(r.gross)}</td>
                <td className="right amount income">{f(r.income)}</td>
                <td className="right amount income">{f(r.collected)}</td>
                <td className={`right amount ${r.outstanding > 0 ? "expense" : "income"}`} data-testid={`account-outstanding-${r.name}`}>{f(r.outstanding)}</td>
                <td className="right"><b>%{r.income ? Math.round((r.collected / r.income) * 100) : 0}</b></td>
              </tr>
            ))}
          </tbody>
          {!!rows.length && (
            <tfoot>
              <tr data-testid="account-summary-total">
                <td><b>Toplam</b></td>
                <td className="right">{f(total.gross)}</td>
                <td className="right amount income">{f(total.income)}</td>
                <td className="right amount income">{f(total.collected)}</td>
                <td className={`right amount ${total.outstanding > 0 ? "expense" : "income"}`}>{f(total.outstanding)}</td>
                <td className="right"><b>%{total.income ? Math.round((total.collected / total.income) * 100) : 0}</b></td>
              </tr>
            </tfoot>
          )}
        </table>
        {!rows.length && <div className="empty-table">Bu dönemde hesaba bağlı gelir veya tahsilat yok.</div>}
      </div>
      <small className="hint">Satıra tıklayarak o hesabı filtreleyebilirsiniz. Giderler hesap bazında ayrıştırılmaz.</small>
    </section>
  );
}
